import { useEffectOnce } from 'react-use';

import { printEntitlementStatement } from '../../EntitlementStatement.utils';

type EntitlementStatementPrintRendererProps = {
   readonly id: number;
   readonly setEntitlementStatementId: (id: number | undefined) => void;
   readonly printWithExplanationsAndNotice: boolean | undefined;
};

// TODO: DREGAB-11754 - znalezienie rozwiązania kaskadowych zapytań command/query
export const EntitlementStatementPrintRenderer = (props: EntitlementStatementPrintRendererProps): null => {
   useEffectOnce(() => {
      printEntitlementStatement(props.id, props.printWithExplanationsAndNotice ?? false);
      props.setEntitlementStatementId(undefined);
   });
   return null;
};
